/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProductServiceCodeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ProductServiceCodeQueryOperator");
    }

    getFixupPrototypeFunction() { return ProductServiceCodeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ProductServiceCodeQueryOperator>): ProductServiceCodeQueryOperator {
        let obj = Object.assign(new ProductServiceCodeQueryOperator(), model);
        ProductServiceCodeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProductServiceCodeQueryOperator>): ProductServiceCodeQueryOperator {
        if (!model) return null;
        return ProductServiceCodeQueryOperator.newInstance(<ProductServiceCodeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProductServiceCodeQueryOperator) {
        if (!obj) return;

        models.ProductServiceCodeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProductServiceCodeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProductServiceCodeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Product service codes to include
     */
    product_service_codes: Array<string>;

}
